import { Component, Input} from '@angular/core';
import { GraphContainer } from 'src/app/model/generic-graph';


@Component({
  selector: 'app-fcf',
  templateUrl: './fcf.component.html',
  styleUrls: ['./fcf.component.scss']
})
export class FcfComponent {
  @Input() graphData: GraphContainer = {} as GraphContainer;
}
